import { useState } from "react";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  CheckCircleOutline,
  Delete,
  HighlightOffOutlined,
} from "@mui/icons-material";
import {
  VenueDetail,
  EventData,
} from "../../../../interfaces/planner.interface";

interface EventVenueDetailsProps {
  eventData: EventData;
  setEventData: React.Dispatch<React.SetStateAction<EventData>>;
}

export const EventVenueDetails = ({
  eventData,
  setEventData,
}: EventVenueDetailsProps) => {
  const [venueDetails, setVenueDetails] = useState<VenueDetail[]>([]);
  const [detailType, setDetailType] = useState<"positive" | "negative">(
    "positive"
  );
  const [detailDescription, setDetailDescription] = useState("");

  const handleAddDetail = () => {
    const newDetail: VenueDetail = {
      id: crypto.randomUUID(),
      type: detailType,
      description: detailDescription,
    };
    setEventData((prevData) => ({
      ...prevData,
      venueDetails: [...prevData.venueDetails, newDetail],
    }));
    setDetailDescription("");
  };

  const handleRemoveDetail = (id: string) => {
    setVenueDetails(venueDetails.filter((detail) => detail.id !== id));
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEventData((prevData) => ({
      ...prevData,
      description: e.target.value,
    }));
  };

  return (
    <Grid container spacing={2} sx={{ marginTop: 2 }}>
      <Grid item xs={12}>
        <Typography
          fontSize={32}
        
          component="div"
          align="left"
          sx={{ marginBottom: 2 }}
        >
          Detalles del evento
        </Typography>
        <Typography
          fontSize={24}
     
          component="div"
          align="left"
          sx={{ marginBottom: 2 }}
        >
          Descripción del evento
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={eventData.description}
          onChange={handleDescriptionChange}
          placeholder="Escribe la descripción del evento aquí"
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <FormControl fullWidth margin="normal">
          <InputLabel>Tipo</InputLabel>
          <Select
            value={detailType}
            label="Tipo de detalle"
            onChange={(e) =>
              setDetailType(e.target.value as "positive" | "negative")
            }
          >
            <MenuItem value="positive">Positivo</MenuItem>
            <MenuItem value="negative">Negativo</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={10}>
        <TextField
          fullWidth
          label="Descripción del detalle"
          value={detailDescription}
          onChange={(e) => setDetailDescription(e.target.value)}
          margin="normal"
        />
      </Grid>
      <Grid item xs={12} mb={2}>
        <Button variant="contained" onClick={handleAddDetail}>
          Añadir
        </Button>
      </Grid>

      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Descripción</TableCell>
                <TableCell>Indicador</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {eventData.venueDetails.map((detail) => (
                <TableRow key={detail.id}>
                  <TableCell colSpan={1}>{detail.description}</TableCell>
                  <TableCell>
                    {detail.type === "positive" ? (
                      <CheckCircleOutline color="success" />
                    ) : (
                      <HighlightOffOutlined color="error" />
                    )}
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleRemoveDetail(detail.id)}>
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
